module.exports = __webpack_public_path__ + "static/media/4th-dimension.bf2763f1.png";